import UploadFiles from "features/UploadFiles";

const UploadPage = () => {
  return <UploadFiles />;
};

export default UploadPage;
